module.exports = __webpack_public_path__ + "static/media/sbg.acfd2007.png";